if (!customElements.get('algolia-product-list')) {  
  customElements.define(
    'algolia-product-list',
    class AlgoliaProductList extends HTMLElement {
      constructor() {
        super();
        this.isInit = false;
        this.algoliaClient = false;
        this.indexPrefix = this.dataset.prefix;
        this.currentIndex = `${this.indexPrefix}products${getSuffix()}`;
        this.productsPerPage = 150;
        this.page = 0;
        this.appliedFilters = '';
        this.query = '';
        this.translationValues = JSON.parse(this.querySelector('[data-translated-facets]')?.innerHTML); //Translation matrix
        this.facetPrefixesExcludedFromDisplay = [ // Partial or full strings
          'options.',
          'named_tags.',
        ];
        this.facetsExcludedFromDisplay = [ // Full strings
          'tags',
          'collections',
          'price_range',
          'price',
          'product_type',
          'collection_ids',
          'inventory_management',
          'vendor',
          'options.color',
          'options.farbe',
          'named_tags.not-good-for',
          'named_tags.good-for',
          'named_tags.category'
        ];
      }
      
      connectedCallback() {    
        if (this.isInit) return;     
        
        if (window.algoliaIsLoaded) {
          this.init();
          return;
        }       
        
        window.addEventListener('algolia:script-loaded', () => {
          this.init();
        });
      }
      
      init() {
        if (this.isInit) return;     
        this.isInit = true;

        const searchParams = new URLSearchParams(window.location.search);
    
        const initialFilterString = searchParams.get('filters') ? decodeURI(searchParams.get('filters')) : false;
        const initialIndex = searchParams.get('index') ? decodeURI(searchParams.get('index')) : false;
        this.query = searchParams.get('q') ? decodeURI(searchParams.get('q')) : '';
        
        if (initialIndex) {
          this.querySelector('[data-action="algolia-sort"]').value = initialIndex;
          this.currentIndex = initialIndex;
        }
        
        this.collectionHandle = this.dataset.collectionHandle;
        this.customerId = this.dataset.customerId || false;
        this.appliedFilters = initialFilterString || this.buildFilterString();
        this.algoliaClient = window.algoliasearch('B8RIKEI9OC', '307ccfad891594b0e4b982aa6a862676');
        this.algoliaClient.initIndex(this.currentIndex);
        this.fetchFilteredResults();
        this.addDelegatedEventListeners();
        this.setStickyFilters();
        document.addEventListener("send-algolia-clicked", this.sendAlgoliaClickedEvent.bind(this));    
      }
      
      addDelegatedEventListeners() {
        ['click', 'change'].forEach((eventType) => {
          this.addEventListener(eventType, debounce((e) => {
            const actionEl = e.target.closest('[data-action]');
            if (!actionEl) return;
            
            const {
              action,
              removeValue,
              gender,
              quickLinkFilter,
            } = actionEl.dataset;
                        
            const searchParams = new URLSearchParams(window.location.search);

            switch(action) {
              case 'algolia-filter-change':
                if (gender) {
                  document.querySelectorAll('[data-algolia-filter-group="named_tags.gender"] input[type="checkbox"][data-action="algolia-filter-change"]').forEach(checkbox => {
                    checkbox.value !== gender ? checkbox.checked = false : checkbox.checked = true
                  });
                }
                if (actionEl.closest('[data-algolia-filter-group="named_tags.gender"]')) {
                  const genderToggle = document.querySelector('input[name="gender-toggle"][value="all"]');
                  if (genderToggle) {
                    genderToggle.checked = true;
                  }
                }

                if (quickLinkFilter) {
                  const split_algolia_filter = quickLinkFilter.split(':');
                  const value = split_algolia_filter[1];

                  document.querySelectorAll('[data-quick-link-filter]').forEach((filter) => {
                    const filter_value = filter.dataset.quickLinkFilter;

                    if (filter_value === quickLinkFilter) {
                      filter.classList.remove('border-ashGray');
                      filter.classList.add('border-black');
                    } else {
                      filter.classList.remove('border-black');
                      filter.classList.add('border-ashGray');
                    }
                  });

                  document.querySelectorAll(`[data-algolia-filter-group] input[type="checkbox"][data-action="algolia-filter-change"]`).forEach(checkbox => {
                    checkbox.value !== value ? checkbox.checked = false : checkbox.checked = true
                  });

                  const productsWrap = this.querySelector('[data-products-wrap]');
                  const position = productsWrap.getBoundingClientRect().top + window.scrollY;
                  window.scrollTo({
                    top: position - 150, 
                    behavior: "smooth"
                  });
                }

                this.appliedFilters = this.buildFilterString();
                this.fetchFilteredResults();
                searchParams.set('filters', encodeURI(this.appliedFilters));
                this.page = 0;
                
                history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);
              break;
              break;
              case 'algolia-sort':
                const sortValue = actionEl.value;
                if (!sortValue || sortValue === this.currentIndex) return;
                searchParams.set('index', sortValue);
                this.currentIndex = sortValue;
                this.page = 0;
                this.fetchFilteredResults();

                history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);
              break;
              
              case 'algolia-pagination-next':
                this.page ++;
                this.fetchFilteredResults(true, true, false);
              break;
              
              case 'remove-algolia-filter':
                if (gender) {
                  document.querySelectorAll('input[name="gender-toggle"][value="all"]').forEach(genderToggle => {
                    genderToggle.checked = true;
                  });
                }
                this.querySelector(`input[data-action="algolia-filter-change"][value="${removeValue}"]:checked`)?.click();
              break;
              case 'remove-all-algolia-filter':
                window.location = window.location.href.split('?')[0];
              break;
              
              case 'open-algolia-filter-drawer':
                this.querySelector('[data-filter-container]')?.classList.add('open');
                document.getElementById('MainContent').classList.remove('z-0');
                document.body.classList.add('overflow-hidden');
              break;
              
              case 'close-algolia-filter-drawer':
                this.querySelector('[data-filter-container]')?.classList.remove('open');
                setTimeout(() => {
                  document.getElementById('MainContent').classList.add('z-0');
                  document.body.classList.remove('overflow-hidden');
                }, 501);
              break;
              
              default: break;
            }
          }), 200);
        });
      }
      
      buildFilterString() {
        let filterString = this.collectionHandle && this.collectionHandle != 'all' ? `collections:${this.collectionHandle}` : '';
                
        const appliedFilters = [...this.querySelectorAll('[data-algolia-filter-group]')].map((filterGroup) => {
          const groupName = filterGroup.dataset.algoliaFilterGroup;
          const appliedValues = [...filterGroup.querySelectorAll('input[type="checkbox"][data-action="algolia-filter-change"]:checked')]
            .map(({ value }) => `${groupName}:"${value}"`).join(' OR ');
          if (!appliedValues.length) return;
          
          return `(${appliedValues})`;
        }).filter((x) => !!x).join(' AND ').toString();
        
        if (appliedFilters.length) {
          filterString = filterString.concat(`${this.collectionHandle && this.collectionHandle != 'all' ? ' AND ' : ''}${appliedFilters} AND NOT tags:base_product AND NOT tags:hide_product`);
        } else filterString = filterString.concat(`${this.collectionHandle && this.collectionHandle != 'all' ? ` AND` : ''} NOT tags:base_product AND NOT tags:hide_product`);
        
        return filterString;
      }
      
      async fetchFilteredResults(filters = true, products = true, replace = true) {
        await this.algoliaClient.multipleQueries([{
          indexName: this.currentIndex,
          clickAnalytics: true,
          params: {
            facets: '*',
            filters: this.appliedFilters,
            hitsPerPage: this.productsPerPage,
            page: this.page,
            query: this.query,
            ruleContexts: this.collectionHandle
          }
        }], 1, false).then((res) => {
          if (res.results[0].userData && res.results[0].userData[0].redirect) {
            window.location.replace(res.results[0].userData[0].redirect);
            return
          }

          const totalResults = res.results[0].nbHits;
          const totalPages = res.results[0].nbPages;
          const queryID = res.results[0].queryID;
          localStorage.setItem(`queryID`, queryID);
          
          if (filters) {
            this.renderFilters(res?.results?.[0]?.facets);
            this.renderFilterRemovalButtons();
            this.renderFilterRemovalButtonsMobile();
          }
          if (products) {
            this.renderProducts(res?.results?.[0]?.hits, replace, res?.results?.[0]?.userData?.[0]?.banners);
          }
          
          if (totalPages <= (this.page + 1)) {
            this.classList.add('fully-loaded');
          } else {
            this.classList.remove('fully-loaded');
          }
          
          if (this.querySelector('[data-products-loaded]')) this.querySelector('[data-products-loaded]').innerText = (this.page + 1) * this.productsPerPage;
          if (this.querySelector('[data-total-products]')) {
            this.querySelectorAll('[data-total-products]').forEach(el => {
              el.innerText = totalResults;
            });
          }
        });
      }

      checkQuickGender() {
        const queryString = window.location.search;
        const regex = /named_tags\.gender%3A%2522(\w+)%2522/;
        const match = queryString.match(regex);
        const gender = match ? match[1] : null;
    
        if (!gender) return;
    
        const radios = document.querySelectorAll('input[type="radio"][data-action="algolia-filter-change"]');
        radios.forEach(radio => {
            if (radio.value === gender) {
                radio.checked = true;
            }
        });
      }
      
      renderCheckbox = ({ label, value, id, swatch, formatAsPrice }) => {
        const searchParams = new URLSearchParams(window.location.search);
        const isChecked = !!decodeURI(searchParams.get('filters'))?.toString()?.includes(`"${value}"`);
        let cosmeticLabel = label.toLowerCase();
        if (this.translationValues.hasOwnProperty(cosmeticLabel)) {
          cosmeticLabel = this.translationValues[cosmeticLabel];
        }
        return `
          <input title="${label}" ${isChecked ? 'checked' : ''} id="${id}" type="checkbox" value="${value}" data-action="algolia-filter-change">
          <label for="${id}">
            ${swatch ? `
              <span 
                style="
                  background-size: contain;
                  background-color: ${label}; 
                  background-image: url('https://www.orthofeet.com/cdn/shop/files/swatch-filter-${encodeURI(label.toLowerCase().replaceAll(' ', '-'))}_small.png');
                " 
                class="swatch"
              ></span>
            ` : ''}
            ${formatAsPrice ? `$${cosmeticLabel.replaceAll(':', ' - $')}` : cosmeticLabel}
          </label>
        `;
      }
      
      renderFilterList(filterName, subValues, id) {
        let label;
        if (filterName.includes('color-family')) {
          label = 'color';
        } else if (filterName.includes('type')){
          label = 'category';
        } else {
          label = filterName.replaceAll('_', ' ').replaceAll('-', ' ');
        }
        if (this.translationValues.hasOwnProperty(label)) {
          label = this.translationValues[label];
        }
        let isGender = this.collectionHandle.includes('men') || this.collectionHandle.includes('women')  ? true : false
        return window.renderAccordionItem({ 
          isOpenByDefault: !!this.querySelector(`[data-accordion-id="${id}"].active`) || label == 'Category' || label == 'Size' || label == 'Width',
          isHidden: filterName == 'gender' && isGender,
          label: label,
          content: `
            <ul data-algolia-filter-group="${id}" data-filter-name="${filterName}" class="filter-list filter-list-${filterName.replace('taille', 'size').replace('größe', 'size')}">
              ${subValues.sort((a, b) => {
                const numA = parseFloat(a);
                const numB = parseFloat(b);
                return numA - numB;
              }).map((value, i) => `
                <li class="filter-list-item ${value}">
                  ${this.renderCheckbox({
                    value, 
                    label: value.replaceAll('_', ' '), 
                    id: `filter-value-${value}-${i}`,
                    swatch: filterName.includes('color'),
                    formatAsPrice: filterName.toLowerCase()?.includes('price')
                  })}
                </li>
              `).join('')}
            </ul>
          `,
          id,
        })
      }
      
      renderFilterGroupFromParentObj({ key, filters, filterValues}) {
        return filterValues.map((optionFilterName) => {
          const filter = `${key}.${optionFilterName}`;
          if (this.facetsExcludedFromDisplay.includes(filter)) return;
          if (!filters[filter]) return;
          
          const subFilterValues = Object.keys(filters[filter]);
          if (!subFilterValues) return;
          
          return this.renderFilterList(optionFilterName, subFilterValues, `${key}.${optionFilterName}`);
        }).join('');
      }
      
      renderFilterRemovalButtons() {
        const filterRemovalButtonsWrap = this.querySelector('[data-remove-filters]');
        if (!filterRemovalButtonsWrap) return;
        
        const appliedValues = [...this.querySelectorAll('input[type="checkbox"][data-action="algolia-filter-change"]:checked')];
        filterRemovalButtonsWrap.innerHTML = '';
        if (!appliedValues.length) return;
        filterRemovalButtonsWrap.insertAdjacentHTML('beforeend', `
          <button title="Remove all filter value" data-action="remove-all-algolia-filter" class="remove-filter-button remove-all-filter-button" data-remove-value="">
            Clear All
          </button>
        `);
        
        appliedValues.forEach((checkedInputEl) => {
          const categoryName = checkedInputEl.closest('[data-filter-name]').dataset.filterName;
          filterRemovalButtonsWrap.insertAdjacentHTML('beforeend', `
            <button title="Remove ${categoryName.replaceAll('_', ' ')} ${checkedInputEl.value} filter value" data-action="remove-algolia-filter" class="remove-filter-button" ${categoryName.includes('gender') ? `data-gender=${checkedInputEl.value}` : ``} data-remove-value="${checkedInputEl.value}">
              ${categoryName.includes('color-family') ? 'Color' : categoryName.replaceAll('_', ' ')}: <span>${checkedInputEl.value}</span>
            </button>
          `);
        });
      }

      renderFilterRemovalButtonsMobile() {
        const filterRemovalButtonsWrap = this.querySelector('[data-remove-filters-mobile]');
        if (!filterRemovalButtonsWrap) return;
        
        const appliedValues = [...this.querySelectorAll('input[type="checkbox"][data-action="algolia-filter-change"]:checked')];
        filterRemovalButtonsWrap.innerHTML = '';
        if (!appliedValues.length) return;
        filterRemovalButtonsWrap.insertAdjacentHTML('beforeend', `
          <button title="Remove all filter value" data-action="remove-all-algolia-filter" class="remove-filter-button remove-all-filter-button" data-remove-value="">
            Clear All
          </button>
        `);
        
        appliedValues.forEach((checkedInputEl) => {
          const categoryName = checkedInputEl.closest('[data-filter-name]').dataset.filterName;
          filterRemovalButtonsWrap.insertAdjacentHTML('beforeend', `
            <button title="Remove ${categoryName.replaceAll('_', ' ')} ${checkedInputEl.value} filter value" data-action="remove-algolia-filter" class="remove-filter-button" ${categoryName.includes('gender') ? `data-gender=${checkedInputEl.value}` : ``} data-remove-value="${checkedInputEl.value}">
              ${categoryName.includes('color-family') ? 'Color' : categoryName.replaceAll('_', ' ')}: <span>${checkedInputEl.value}</span>
            </button>
          `);
        });
      }
      
      renderFilters(filters) {
        if (!filters) return;
        const filtersWraps = this.querySelectorAll('[data-filters-wrap]');       
        
        // renderAccordionItem() from accordion.js
        filtersWraps.forEach((filterWrap, i) => {
          filterWrap.innerHTML = `
            <content-accordion> 
              <ul>
                ${Object.keys(filters).map((filter) => {
                  if (this.facetsExcludedFromDisplay.includes(filter) || this.facetPrefixesExcludedFromDisplay.find((prefix => filter.includes(prefix)))) return;
                                    
                  const filterValues = Object.keys(filters[filter]);

                  if (filter.includes('option_names') || filter.includes('named_tags_names')) {
                    let key = filter.replace('_names', '');
                    if (key.slice(-1) !== 's') {
                      key = key.concat('s');
                    }
                    
                    return this.renderFilterGroupFromParentObj({ 
                      key, 
                      filters: filters, 
                      filterValues: filterValues
                    });
                  }
                                    
                  return this.renderFilterList(filter, filterValues, filter);
                }).join('')} 
              </ul>
            </content-accordion> 
          `;
        });
      }
      
      renderProducts(products, replace = true, banners = false) {
        const productsWrap = this.querySelector('[data-products-wrap]');
        if (!productsWrap) return;
        
        if (!products.length) {
          productsWrap.innerHTML = `
            <div class="no-results">
              <h3>No products match your query. Adjust your filters and try again.</h3>
            </div>
          `;
          return;
        };
        
        if (replace) productsWrap.innerHTML = '';
        
        products.forEach((product, index) => {
          if (banners) {
            const indexBanner = banners.filter((banner) => banner.position - 1 == index).length ? banners.filter((banner) => banner.position - 1 == index)[0] : false;

            if(indexBanner) {
              const indexBannerURL = indexBanner.url ? indexBanner.url : false;
              const indexBannerImageURL = indexBanner.image_url ? indexBanner.image_url : '';
              const indexMobileBannerImageURL = indexBanner.mobile_image_url ? indexBanner.mobile_image_url : '';
              const indexBannerVideoURL = indexBanner.video_url ? indexBanner.video_url : '';
              const indexMobileBannerVideoURL = indexBanner.mobile_video_url ? indexBanner.mobile_video_url : '';
              const indexBannerTitle = indexBanner.title ? indexBanner.title : '';
              const indexBannerText = indexBanner.text ? indexBanner.text : '';
              const bannerTextWrapper = `
              <div class="absolute top-0 gap-2 z-10 flex flex-col w-full h-full text-[#FFF] p-7 font-heading">
                <span class="font-medium leading-none md:text-[44px]">${indexBannerTitle}</span>
                <span class="text-l md:leading-none">${indexBannerText}</span>
              </div>`;

              productsWrap.insertAdjacentHTML(
                'beforeend',
                `<div class="relative w-full h-full flex">
                  ${indexBannerURL ? `<a class="w-full h-full flex" href="${indexBannerURL}">` : ``}
                    ${indexBannerVideoURL ? 
                      `${indexMobileBannerVideoURL ? `<video src="${indexMobileBannerVideoURL}" autoplay loop muted playsinline width="300" height="400" class="rounded-lg w-full h-full object-cover object-center lg:hidden"></video>` : ``}
                      <video src="${indexBannerVideoURL}" autoplay loop muted playsinline width="600" height="800" class="rounded-lg w-full h-full object-cover object-center ${indexMobileBannerVideoURL ? 'hidden lg:block' : ''}"></video>`
                      : `${indexMobileBannerImageURL ? `<img src=${indexMobileBannerImageURL} loading="lazy" width="300" height="400" class="rounded-lg w-full object-cover object-center lg:hidden">` : ``}
                      <img width="600" height="800" src=${indexBannerImageURL} loading="lazy" class="rounded-lg w-full object-cover object-center ${indexMobileBannerImageURL ? 'hidden lg:block' : ''}">`
                    }
                    ${indexBannerTitle || indexBannerText ? bannerTextWrapper : ''}
                  ${indexBannerURL ? `</a>` : ``}
                </div>`
              )
            }
          }

          productsWrap.insertAdjacentHTML( // intersection-loader from intersection-loader.js
            'beforeend',
            `<intersection-loader 
              data-url="${Shopify.routes.root}${this.collectionHandle ? `collections/${this.collectionHandle}/`: ''}products/${product.handle}" 
              data-section-id="product-tile"
              data-object-id="${product.objectID}"
              data-position="${product.position}"
            >
              <div class="loading animate-pulse w-full aspect-[4/5] bg-mercury shadow rounded-lg relative flex items-center justify-center">
                <div class="loader !bg-transparent">
                  <span class="block w-12 h-12">
                    <svg class="animate-spin -ml-1 mr-3 h-full w-full text-primaryBrand" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </span>
                </div>
              </div>
            </intersection-loader>`
          )
        });
      }

      sendAlgoliaClickedEvent(e) {
        const productListThis = this;
        const queryID = localStorage.getItem('queryID');

        if (!productListThis.customerId || !e.detail.objectId || !e.detail.position) return;

        aa('clickedObjectIDsAfterSearch', {
          userToken: productListThis.customerId,
          eventName: 'Product Clicked After Search',
          index: this.currentIndex,
          queryID: queryID,
          objectIDs: [e.detail.objectId],
          positions: [Number(e.detail.position)],
        });
      }

      setStickyFilters() {
        if (window.innerWidth >= 1024) return;
        const productsWrapper = document.querySelector("[data-products-wrap]");
        const stickyFilters = document.querySelector("[data-sticky-filters]");
        const filtersHead = document.querySelector("[data-filters-head]");
        const headerHeight = document.querySelector("header")?.offsetHeight || 0;
        const fullAnnouncementBarHeight = document.querySelector("[data-sticky-annouce]")?.offsetHeight || 0;
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            stickyFilters.style.transform = `unset`;
            stickyFilters.style.top = 'unset';
            stickyFilters.classList.remove('sticky', 'w-full', 'left-0', 'z-20', 'border-b', 'border-mercury');
            productsWrapper.classList.remove('pt-4');
          } else {
            stickyFilters.style.transform = `translateY(${headerHeight + fullAnnouncementBarHeight}px)`;
            stickyFilters.style.top = '0';
            stickyFilters.classList.add('sticky', 'w-full', 'left-0', 'z-20', 'border-b', 'border-mercury');
            productsWrapper.classList.add('pt-4');
          }
        }, { threshold: 0 });

        observer.observe(filtersHead);
      }
    }
  )
}